import {writable, Writable} from "svelte/store";

export const jwt: Writable<string|null> = writable(localStorage.jwt);
export async function logout() {
    let result = await authFetch('/logout', {
        method: 'GET',
        headers: {
            "content-type": "application/json"
        }
    })
    if(result.ok){
        localStorage.removeItem('jwt')
        jwt.set(null)
    }else{
        alert(result.statusText)
    }
}
export async function login(username: string, password: string){
    let result = await fetch('/login', {
        method: 'POST',
        headers: {"content-type": "application/json"},
        body: JSON.stringify({username, password})
    })
    if(result.ok){
        let token = (await result.json()).token
        localStorage.setItem('jwt', token)
        jwt.set(token)
    }else{
        alert(result.statusText)
    }
}

export async function authBlobUrl(input: RequestInfo, init: RequestInit = {}): Promise<string>{
    let response = await authFetch(input, init)
    if(response.ok){
        let blob = await response.blob()
        return window.URL.createObjectURL(blob)
    }else{
        // console.error(response.statusText)
        return null
    }
}


export function authFetch(input: RequestInfo, init: RequestInit = {}): Promise<Response> {
    let headers = init.headers ?? {}
    headers["Authorization"] = `Bearer ${localStorage.jwt}`
    init.headers = headers
    return fetch(input, init).then((response: Response)=>{
            if(response.status === 403){
                localStorage.removeItem('jwt')
                jwt.set(null)
            }
            return response;
        });
}
